export default __webpack_public_path__ + "static/media/endorsement.c5fa55ec.svg";